import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { CREAM, GREEN, INK } from "../components/tournament/PublicParts";
import { resolveScreenCode } from "../lib/tournamentApi";

const KEY = "chalkos.screenCode";

/** TV pairing: go to /screen, type the 4 digits after CHALK-, land on the Big Screen. */
export default function ScreenPair() {
  const nav = useNavigate();
  const [digits, setDigits] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);

  async function go(d) {
    setBusy(true); setError(null);
    try {
      const r = await resolveScreenCode(`CHALK-${d}`);
      localStorage.setItem(KEY, d);
      nav(`/t/${r.slug}/screen`, { replace: true });
    } catch (e) {
      localStorage.removeItem(KEY);
      setError(e.message || "That code didn't work.");
      setDigits("");
      ref.current?.focus();
    } finally { setBusy(false); }
  }
  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (saved) go(saved);
    else ref.current?.focus();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function onChange(v) {
    const d = v.replace(/\D/g, "").slice(0, 4);
    setDigits(d);
    if (d.length === 4) go(d);
  }
  return (
    <div data-testid="screen-pair-page" style={{ background: INK, color: CREAM, minHeight: "100vh", display: "flex", flexDirection: "column",
                                                  alignItems: "center", justifyContent: "center", fontFamily: "Barlow, system-ui, sans-serif", padding: "4vw" }}>
      <div style={{ fontSize: "clamp(18px, 2vw, 40px)", letterSpacing: "0.2em", opacity: 0.7, fontWeight: 800 }}>CHALKOS BIG SCREEN</div>
      <div style={{ fontSize: "clamp(22px, 2.4vw, 48px)", marginTop: "1vw" }}>Enter the code from Showcase → Big Screen</div>
      <label style={{ display: "flex", alignItems: "center", gap: "1vw", marginTop: "3vw", fontFamily: "'Bebas Neue', sans-serif",
                      fontSize: "clamp(56px, 9vw, 180px)", lineHeight: 1 }}>
        <span>CHALK-</span>
        <input ref={ref} value={digits} onChange={(e) => onChange(e.target.value)} inputMode="numeric" pattern="[0-9]*" maxLength={4}
               autoFocus disabled={busy} data-testid="screen-pair-input" aria-label="Screen code digits" placeholder="0000"
               style={{ width: "5ch", background: "rgba(245,240,232,0.08)", color: CREAM, border: `0.3vw solid ${GREEN}`, borderRadius: "1vw",
                        font: "inherit", textAlign: "center", padding: "0 0.3ch", outline: "none" }} />
      </label>
      {busy && <div data-testid="screen-pair-busy" style={{ marginTop: "2vw", fontSize: "clamp(18px, 1.8vw, 36px)" }}>Connecting…</div>}
      {error && <div data-testid="screen-pair-error" style={{ marginTop: "2vw", fontSize: "clamp(18px, 1.8vw, 36px)", color: "#ff9b8f" }}>{error}</div>}
      <div style={{ marginTop: "3vw", fontSize: "clamp(14px, 1.2vw, 24px)", opacity: 0.55 }}>Use the number keys on your remote or keyboard.</div>
    </div>
  );
}
